import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    errorMessage: {
      padding: theme.spacing(0, 2),
    },
    badgeItemRoot: {
      alignItems: 'flex-start',
      width: '100%',
    },
    list: {
      display: 'flex',
      flexWrap: 'wrap',
    },
  };
};
